import { useMemo } from 'react'

import { RouteConfig } from '../routing/RenderRoutes'
import { useAccountReadContext } from '../utils/AccountContextContext'
import { TickmillCompaniesEnum } from '../utils/companyName.utils'
import { SocialTradingPage } from './SocialTradingPage'

export const useSocialTradingRoutes = (): RouteConfig[] => {
  const visible = useSocialTradingRoutesConditions()

  return useMemo(
    (): RouteConfig[] => [
      {
        path: 'social-trading',
        element: <SocialTradingPage />,
        condition: visible.isSocialTradingVisible,
      },
    ],
    [visible.isSocialTradingVisible]
  )
}

interface RoutesConditions {
  isSocialTradingVisible: boolean
}

export const useSocialTradingRoutesConditions = (): RoutesConditions => {
  const { account } = useAccountReadContext()

  const isSocialTradingVisible = useMemo(
    () => account?.tickmillCompany.id === TickmillCompaniesEnum.TICKMILL_SC,
    [account]
  )

  return {
    isSocialTradingVisible,
  }
}
